import React from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const UBDFooterButtons = ({
  onSaveAsDraft,
  onSubmit,
  handleCancel,
  approve,
  formValid,
  checkReadWriteAccess,
  taskStatus,
  showCancelTaskButton = false,
  IsEnabledCancelTask = false,
  onCancelTask = () => {},
}) => {
  const location = useLocation();
  const locationPath = location?.pathname;
  const url = locationPath?.split("/");
  const pathName = url[2];

  return (
    <div
      className={"form-buttons bottom-fixed"}
      style={{ background: "#FAFAFA" }}
    >
      {showCancelTaskButton && (
        <>
          <Button
            className="button-layout"
            type="submit"
            onClick={() => onCancelTask()}
            disabled={!IsEnabledCancelTask}
          >
            Cancel Task
          </Button>
        </>
      )}
      <Button
        className={"button-layout"}
        variant="secondary"
        onClick={() => handleCancel()}
      >
        Back
      </Button>
      {!approve && (
        <>
          <Button
            className="button-layout"
            type="submit"
            onClick={() => onSubmit()}
            disabled={formValid || taskStatus === "Complete" ||!checkReadWriteAccess}

          >
            Submit
          </Button>
        </>
      )}
    </div>
  );
};

export default UBDFooterButtons;
